import {
  COACH_WELCOME_LANE_LABEL,
  type WorkQueueLane,
} from "@care-by-ella/contracts";

// The work queue's section names, one per lane. Pure, so the queue routes,
// the card's "Följ upp senare" and the admin's node tests share them.
export const LANE_LABEL: Record<WorkQueueLane, string> = {
  // TES-1189 — Emelie's section name.
  new_patients: COACH_WELCOME_LANE_LABEL,
  handoffs: "Överlämningar",
  follow_ups: "Uppföljningar",
  // TES-1214 — A-01's section name.
  checkins: "Veckoincheckningar",
  labs: "Blodprov",
  missed_checkins: "Missade incheckningar",
  // TES-751 — Emelie's name for the section. "Följsamhetsrisk" claimed
  // something about the patient that the signal never measured; this says what
  // the coach should do.
  adherence_risk: "Behöver återkontakt",
  program_changes: "Programändringar",
  renewals: "Förnyelser att besluta",
  onboarding: "Onboarding",
  side_effects: "Rapporterade biverkningar",
  medical_alerts: "Medicinska larm",
  // TES-986 — F-04 answers that route to the doctor, and what a coach sent
  // on with "Skicka till läkare".
  medical_reviews: "Medicinska ärenden",
  // TES-765 — an administrative tail, not an alarm: the patient's care has
  // already moved on, but the confirmation must not be forgotten.
  webdoc_confirmations: "Infört i Webdoc saknas",
  // TES-1233 — A-02's queue name, 2026-10-13 (TES-1404).
  meetings_to_document: "Passerade möten",
  // TES-1059 — one item per completion round once everything asked for is in.
  completion_rounds: "Kompletteringar klara",
  // TES-1149 — one item per answered doctor's question.
  doctor_question_answers: "Svar på läkarens fråga",
};
